<vb-title [title]="video?.title + ' - ' + ('Title_VideoPlayer' | translate)"></vb-title>

@if(video) {
	<div *ngIf="video" [ngClass]="styles.wrapper" layout="column" layout-wrap="false" [ngStyle]="{ height: height }">

		<vb-loading-spinner *ngIf="isLoadingInitialVideo" flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
		</vb-loading-spinner>

		<vb-page-header *ngIf="!config?.hidePlaybackTitleHeader && !isLoadingInitialVideo" [headerText]="video.title" [themedBorder]="true">
			<video-playback-processing-progress-bar *ngIf="video.canEditVideo" [isProcessing]="video.isProcessing" [overallProgress]="video.overallProgress" [videoId]="video.id" [videoStatus]="video.status">
			</video-playback-processing-progress-bar>

			<video-playback-settings-menu *ngIf="config.showSettingsMenu && !config?.isEmbedFullPlayer" [hidden]="isEditorMode || isOverlayDialogOpen" [mediaFeatures]="mediaFeatures" [playbackConfig]="config" [video]="video">
			</video-playback-settings-menu>

			<a *ngIf="config.showCloseBtn" class="glyphicons remove_2" (click)="goToPreviousState()" vbBtnPrimary>
			</a>
		</vb-page-header>

		<preposition-dialog *ngIf="isPrepositionOpen" [ngClass]="styles.overlayDialog" [video]="video" (onClose)="onPrepositionDialogClose()">
		</preposition-dialog>

		<replace-video-dialog *ngIf="canEditVideo" [ngClass]="styles.overlayDialog" [hidden]="!isReplaceVideoOpen" [isOpen]="isReplaceVideoOpen" [video]="video" (onClose)="onReplaceVideoDialogClose()">
		</replace-video-dialog>

		<approval-process-container *ngIf="config.showApprovalProcess
				&& isUserAuthenticated
				&& !isLoadingInitialVideo
				&& !video.legalHold" [video]="video" (deleteVideoEvent)="deleteVideo()">
		</approval-process-container>

		<vb-ui-sidebar-layout *ngIf="!isLoadingInitialVideo && !isReportsOpen" #sidebarLayout flex="fill" [hideSidebar]="isEditorMode || !config.showSidebar" [sidebarConfig]="sidebarConfig" [themed]="true" [noBorder]="true" [isMobileLayoutDisabled]="config.disableMobileLayout" [hasLowerContent]="config.showRecommendedVideos && mediaFeatures.enableRecommendedVideoPlayback && !config.isEmbedFullPlayer" [mobileLayoutBreakPointSize]="config.mobileLayoutBreakPointSize" [ngClass]="[styles.sidebarLayout]" (onSidebarToggle)="onSidebarToggle($event)">
			<div slot="mainContent">
				<div *ngIf="!isEmbedPreviewEnabled; else embedPreview" layout="column" layout-wrap="false" [ngClass]="styles.fill">
					<vb-loading-spinner *ngIf="isLoadingNewVideo" flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
					</vb-loading-spinner>

					<div *ngIf="!isLoadingNewVideo" flex="fill" flex-justify="center" flex-align="stretch" layout="column" layout-gt-md="row" layout-wrap="false">

						<div flex="fill" flex-align="center" flex-justify="center" layout [ngClass]="styles.playerRegion" [vbWatchDimensions]="[videoPlaybackWrapper]" [padding]="config.playerPadding ?? 32">
							<div class="position-absolute">
								<div #videoPlaybackWrapper class="video-playback-player-wrapper">
									<video-text-status *ngIf="!isRecordingStatusSurfaced" [approvalStatus]="video.approval.status" [videoIsActive]="video.isActive" [isUnlisted]="video.unlisted" [hasMediaEditAuth]="hasMediaEditAuth || video.canEditVideo" [isVideoOwner]="isVideoOwner" [isOnLegalHold]="video.legalHold">
									</video-text-status>

									<video-playback-status-msg *ngIf="!isRecordingStatusSurfaced && playableStatus" [pageStatus]="{active: true}" [playableStatus]="playableStatus" [showRestoreBtn]="video.isReplacing" [videoId]="video.id">
									</video-playback-status-msg>

									<recording-process *ngIf="isRecordingStatusSurfaced" class="text-white" [video]="video">
									</recording-process>

									<vb-video-player *ngIf="isReadyToPlay" [audioTracks]="video.audioTracks" [chapters]="video.chapterInfo.chapters" [autoShowChapterImages]="video.enableAutoShowChapterImages" [autoPlay]="params.autoplay" [disableDualPlayback]="config.disableDualPlayback || !video.hasDualStreams" [disableUserPreferenceStore]="config.disableUserPreferenceStore" [durationMs]="video.duration" [hasAudioOnly]="video.hasAudioOnly" [heartbeatIntervalSecs]="video.heartbeatInterval" [is360]="video.is360" [isCaptionsAvailable]="video.closedCaptionsEnabled" [live]="video.isLive" [muteBtnOnLeft]="isMuteBtnOnLeft" [playerConfig]="config.playerConfig" (onPlay)="onPlay()" (onPlaybackEnded)="onPlaybackEnded()" (onPlayerReady)="onPlayerReady($event.vgAPI)" [playbacks]="video.playbacks" [resumeSessionId]="video.sessionId" [sourceType]="video.sourceType" [startAt]="video.initialStartAt?.startAt" [startAtResume]="video.initialStartAt?.startAtResume" [subtitles]="video.subtitles" [thumbnailCfg]="video.thumbnailCfg" [thumbnailUri]="video.thumbnailUri || (video.hasAudioOnly ? '/shared/img/audio-thumbnail.png' : '')" [timeMarkers]="markers" [videoId]="video.id" [videoTitle]="video.title" [videoOverlays]="video.videoOverlays" [viewContext]="config.analyticsViewContext || analyticsViewContext" (onPlayerSizeChanged)="onPlayerSizeChanged($event)">
									</vb-video-player>
								</div>
							</div>
						</div>
					</div>

					<video-playlist-carousel *ngIf="playlistId && !isEditorMode" [currentVideoId]="videoId" [videos]="playlist?.videos" (onSelectionChanged)="loadPlaylistVideo($event.videoId)">
					</video-playlist-carousel>
				</div>

				<ng-template #embedPreview>
					<vb-media-embed-preview [ngClass]="styles.embedPreview"></vb-media-embed-preview>
				</ng-template>
			</div>

			<div slot="sidebarHeaderControls">
				@switch(activeSidebarButtonId) {
					@case (VideoPlaybackSidebarButton.PULSE) {
						<vb-ui-search-input [ngClass]="styles.sidebarHeaderSearchInput" [(ngModel)]="sidebarFilter" [placeholder]="'Media_Videos_Search_SearchPlaceholder' | translate">
						</vb-ui-search-input>
					}
					@case (VideoPlaybackSidebarButton.AI) {
						<div class="dropdown" [ngClass]="menuItemStyles.menu" dropdown vbDropdown [insideClick]="true" #aiDropdown="bs-dropdown">
							<button type="button" class="dropdown-toggle" [attr.aria-label]="('Media_Videos_Assistant' | translate) + ' - ' + ('UI_Menu' | translate)" dropdownToggle vbBtnPrimary>
								<span class="vb-icon vb-icon-center vb-icon-dots vb-icon-rotate-90"></span>
							</button>
							<ul *dropdownMenu role="menu" class="dropdown-menu dropdown-menu-right" [ngClass]="[menuItemStyles.menuOrderedList, menuItemStyles.menuDark]">
								<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
									<button type="button" class="dropdown-item themed-menu-item" [disabled]="VideoAiAssistantService.chatState().isWaitingForChatResponse || VideoAiAssistantService.chatState().showStillWorkingMessage" (click)="onClearConversationClick()">
										{{ 'ClearConversation' | translate }}
									</button>
								</li>
							</ul>
						</div>
					}
				}

				
			</div>

			<div slot="sidebarPanel">
				<video-playback-sidebar-panel [selectedButtonId]="activeSidebarButtonId" [playbackConfig]="config" (onCloseSidebar)="onCloseSidebar()">
				</video-playback-sidebar-panel>
			</div>
		</vb-ui-sidebar-layout>

		<video-playback-reports *ngIf="isReportsOpen" flex="fill" [video]="video" [mediaFeatures]="mediaFeatures" [playbackConfig]="config" (onClose)="onVideoPlaybackReportsClose()">
		</video-playback-reports>
	</div>
	@if(config.showRecommendedVideos && mediaFeatures.enableRecommendedVideoPlayback && !config.isEmbedFullPlayer) {
		<video-playback-recommended [ngClass]="activeSidebarButtonId ? styles.recommendedHideMobile : null" [videoId]="video.id"></video-playback-recommended>
	}
}
